module.exports = __webpack_public_path__ + "img/4c.7f2fadf1.svg";